import { Route, Switch } from "react-router-dom";
import { Layout } from "./containers/Layout/Layout";
import { SearchPage } from "./containers/SearchPage/SearchPage";
import { UsersDashboard } from "./containers/UsersDashboard/UsersDashboard";
import { Unauthorized } from "./containers/Unauthorized/Unauthorized";
import { CrewMember } from "./containers/CrewMember/CrewMember";
import { ChangeLog } from "./containers/ChangeLog/ChangeLog";
import { fetchCountriesAndNationalities } from "./store/nationalitiesReducer";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Statistics } from "./containers/Statistics/Statistics";
import { Inbox } from "./containers/Inbox/Inbox";
import { InboxMessageDetails } from "./containers/Inbox/InboxMessageDetails";
import { fetchUnreadMessages } from "./store/unreadMessagesReducer";
import axios from "axios";
import { logout, UserData } from "./actions/authentificationActions";
import { AppState } from "./store/configureStore";
import { fetchExaminationOrganizations } from "./store/examinationOrganizationsReducer";
import { fetchPaymentTypes } from "./store/paymentTypesReducer";
import "./App.css";
import { IcsAplicationView } from "./containers/Certificates/IcsAplicationView";
import { AdminSettingsView } from "./containers/AdministratorSettings/AdminSettingsView";

axios.interceptors.request.use(config => {
    const userData = sessionStorage.getItem("user");
    if (userData) {
        const user = JSON.parse(userData) as UserData;
        config.headers!.Authorization = "Bearer " + user.token;
    }
    return config;
});
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        console.error(error);
        return Promise.reject(error);
    }
);

const parseJwt = (token: string) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
        Buffer.from(base64, "base64")
            .toString()
            .split("")
            .map(c => {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );
    return JSON.parse(jsonPayload).exp;
};

export const App = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: AppState) => state.user);
    const exp = parseJwt(user.token!) as number;

    const fetchDataCallback = useCallback(() => {
        fetchCountriesAndNationalities(dispatch);
        fetchUnreadMessages(dispatch);
        fetchExaminationOrganizations(dispatch);
        fetchPaymentTypes(dispatch);
    }, [dispatch]);

    useEffect(() => {
        fetchDataCallback();
    }, [fetchDataCallback]);

    useEffect(() => {
        if (window.location.host.includes("test.")) document.title = "TEST " + document.title;
    }, []);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (new Date().getTime() > new Date(exp * 1000).getTime()) {
                localStorage.setItem("autoLogout", "true");
                dispatch(logout());
            }
            fetchUnreadMessages(dispatch);
        }, 30000);
        return () => clearInterval(intervalId);
    }, [dispatch, exp]);

    return (
        <Layout>
            <Switch>
                <Route path="/unauthorized" component={Unauthorized} />
                <Route path="/search" component={SearchPage} />
                <Route path="/manage-users" component={UsersDashboard} />
                <Route exact path="/crew-members/:guid" component={CrewMember} />
                <Route exact path="/change-log" component={ChangeLog} />
                <Route exact path="/statistics" component={Statistics} />
                <Route exact path="/inbox/:guid" component={InboxMessageDetails} />
                <Route exact path="/inbox" component={Inbox} />
                <Route exact path="/ics-aplications" component={IcsAplicationView} />
                <Route exact path="/administrator-settings" component={AdminSettingsView} />
                <Route component={SearchPage} />
            </Switch>
        </Layout>
    );
};
